export let reviewTypes: { [index: string]: number } = {
  contactDuplicate: 1,
  giftBeforePledgeStartDate: 2,
  duplicatePledges: 3,
};

export let reviewTypeNames: { [index: number]: string } = {};
Object.keys(reviewTypes).forEach((key) => {
  reviewTypeNames[reviewTypes[key]] = key;
});

export let reviewTypeLabels: { [index: number]: string } = {};
reviewTypeLabels[reviewTypes.contactDuplicate] = 'Contact Duplicate';
reviewTypeLabels[reviewTypes.giftBeforePledgeStartDate] =
  'Gift Before Pledge Start Date';
reviewTypeLabels[reviewTypes.duplicatePledges] = 'Possible Duplicate Pledges';
